import React from 'react';
import {connect} from 'react-redux';
import {SECTION_TYPE_TEXT} from '../../constants';
import {closeEditTextSection, updateTextSectionContents} from '../../actions';
import {
    selectSectionSettingInTheSectionEditPopup,
    selectImageSettingInTheSectionEditPopup,
    selectVideoSettingInTheSectionEditPopup,
    updateImagesInTheSectionEditPopup,
    updateImagesSortOrderInTheSectionEditPopup,
    deleteImageFromTheSectionEditPopup,
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
    updateVideoUrlFieldInTheSectionEditPopup,
    updateInstructionsFieldInTheSectionEditPopup,
    updateCroppedImageInTheSectionEditPopup,
    updateThumbCroppedImageInTheSectionEditPopup,
    updateImageMetaInTheSectionEditPopup,
    updateImageCropRatioInTheSectionEditPopup,
} from '../../sections/actions';
import {
    fetchSectionSettings,
    fetchImageSettings,
    fetchVideoSettings,
} from '../../../pages/settings/thunks';
import {fetchImageRatios} from '../../../images/thunks';
import TextSectionEditPopup from './text_section_edit';

class TextPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.textSectionEditOpen === true &&
            this.props.textSectionEditOpen === false
        ) {
            if (
                !this.props.allSectionSettings ||
                this.props.allSectionSettings.length === 0
            ) {
                this.props.fetchSectionSettings();
            }
            if (
                !this.props.allImageSettings ||
                this.props.allImageSettings.length === 0
            ) {
                this.props.fetchImageSettings();
            }
            if (
                !this.props.allVideoSettings ||
                this.props.allVideoSettings.length === 0
            ) {
                this.props.fetchVideoSettings();
            }
            if (
                !this.props.imageRatios ||
                this.props.imageRatios.length === 0
            ) {
                this.props.fetchImageRatios();
            }
        }
    }

    render() {
        const textSectionSettings = this.props.allSectionSettings.filter(
            (setting) => Number(setting.section_type_id) === SECTION_TYPE_TEXT
        );

        const textSectionImageSettings = this.props.allImageSettings.filter(
            (setting) => Number(setting.section_type_id) === SECTION_TYPE_TEXT
        );

        const textSectionVideoSettings = this.props.allVideoSettings.filter(
            (setting) => Number(setting.section_type_id) === SECTION_TYPE_TEXT
        );

        return (
            <TextSectionEditPopup
                sectionSettings={textSectionSettings}
                imageSettings={textSectionImageSettings}
                videoSettings={textSectionVideoSettings}
                open={this.props.textSectionEditOpen}
                title={this.props.textSectionTitle}
                body={this.props.textSectionBody}
                textSectionId={this.props.textSectionId}
                sectionTypeText={this.props.sectionTypeText}
                instructions={this.props.textSectionInstructions}
                images={this.props.sectionImages}
                videos={this.props.sectionVideos}
                imageRatios={this.props.imageRatios.text}
                selectedSectionSettings={this.props.selectedSectionSettings}
                selectedImageSettings={this.props.selectedImageSettings}
                selectedVideoSettings={this.props.selectedVideoSettings}
                selectSectionSetting={this.props.selectSectionSetting}
                selectImageSetting={this.props.selectImageSetting}
                selectVideoSetting={this.props.selectVideoSetting}
                onUpdateImagesField={this.props.updateImagesSectionFields}
                onUpdateImagesSortOrder={
                    this.props.updateImagesSectionSortOrder
                }
                onDeleteImageField={this.props.deleteImageFromSectionField}
                onUpdateTitleField={this.props.updateTextSectionTitleField}
                onUpdateBodyField={this.props.updateTextSectionBodyField}
                onUpdateVideoUrlField={
                    this.props.updateTextSectionVideoUrlField
                }
                onUpdateInstructionsField={
                    this.props.updateTextSectionInstructionsField
                }
                onCropImage={this.props.updateCroppedImage}
                onCropThumbImage={this.props.updateThumbCroppedImage}
                onImageMetaUpdate={this.props.updateImageMeta}
                onImageCropRatioUpdate={this.props.updateImageCropRatio}
                onHandleRequestDone={() =>
                    this.props.updateTextSectionContents(
                        this.props.pageId,
                        this.props.textSectionId,
                        this.props.sectionData,
                        this.props.selectedSectionSettings,
                        this.props.selectedImageSettings,
                        this.props.selectedVideoSettings
                    )
                }
                onHandleRequestClose={this.props.closeTextSectionPopup}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSectionSettings: state.pageBuilderSectionPopup.sectionSettings,
    selectedImageSettings: state.pageBuilderSectionPopup.imageSettings,
    selectedVideoSettings: state.pageBuilderSectionPopup.videoSettings,
    textSectionEditOpen: state.pageBuilder.textSectionPopup.open,
    textSectionTitle: state.pageBuilderSectionPopup.data.title,
    textSectionBody: state.pageBuilderSectionPopup.data.body,
    textSectionInstructions: state.pageBuilderSectionPopup.data.instructions,
    textSectionPageId: state.pageBuilderSectionPopup.pageId,
    sectionImages: state.pageBuilderSectionPopup.data.images,
    sectionVideos: state.pageBuilderSectionPopup.data.videos,
    textSectionId: state.pageBuilderSectionPopup.sectionId,
    imageRatios: state.images.ratios,
    allSectionSettings: state.sectionsSettings.sectionSettings,
    allImageSettings: state.sectionsSettings.imageSettings,
    allVideoSettings: state.sectionsSettings.videoSettings,
});

export default connect(mapStateToProps, {
    selectSectionSetting: selectSectionSettingInTheSectionEditPopup,
    selectImageSetting: selectImageSettingInTheSectionEditPopup,
    selectVideoSetting: selectVideoSettingInTheSectionEditPopup,
    updateImagesSectionFields: updateImagesInTheSectionEditPopup,
    updateImagesSectionSortOrder: updateImagesSortOrderInTheSectionEditPopup,
    deleteImageFromSectionField: deleteImageFromTheSectionEditPopup,
    updateTextSectionTitleField: updateTitleFieldInTheSectionEditPopup,
    updateTextSectionBodyField: updateBodyFieldInTheSectionEditPopup,
    updateTextSectionVideoUrlField: updateVideoUrlFieldInTheSectionEditPopup,
    updateTextSectionInstructionsField: updateInstructionsFieldInTheSectionEditPopup,
    updateCroppedImage: updateCroppedImageInTheSectionEditPopup,
    updateThumbCroppedImage: updateThumbCroppedImageInTheSectionEditPopup,
    updateTextSectionContents: updateTextSectionContents,
    updateImageMeta: updateImageMetaInTheSectionEditPopup,
    updateImageCropRatio: updateImageCropRatioInTheSectionEditPopup,
    closeTextSectionPopup: closeEditTextSection,
    fetchSectionSettings,
    fetchImageSettings,
    fetchVideoSettings,
    fetchImageRatios,
})(TextPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/text_popup.js